<div class="container-fluid">
    <div class="row">
      <div class="col-md-7">
        <div class="row g-3">
            <div class="col-12">
                <div class="card shadow-sm">
                    <div class="card-header">
                      <h3 class="card-title">Request Details</h3>
                      @if (canEditRequest) {
                        <button
                          type="button"
                          class="btn btn-success ms-auto"
                          (click)="goToEditRequest()"
                          [disabled]="!requestId">
                          Edit Request
                        </button>
                      }
                    </div>
                    <div class="card-body">
                      <requests-form [request]="request" [readonlyRequestForm]="readonly" [isEditPage]="false"/>
                    </div>
                  </div>
            </div>
            <div class="col-12">
                <requests-details [request]="request" [readonlyRequestDetails]="readonly"/> 
            </div>
        </div>
      </div>
      <div class="col-md-5">
        <requests-date [request]="request" [requestCategory]="category" [readonlyRequestDate]="readonly"/>
      </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
             <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="requestNotes"
        [noteServiceMethod]="requestsService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'"
        [sectionAttribute]="'requestId'"/>
        </div>
    </div>
    @if (canCreateProposal) {
      <div class="row mt-3">
          <div class="col-md-12 text-center">
              <button [disabled]="request?.showProceedToProposal !== true" type="button" class="btn btn-primary" (click)="proceedToProposals()">
                  Proceed to Proposals
              </button>
          </div>
      </div>
    }
  </div>